<template>
  <el-select
    v-model="shopIdArr"
    multiple
    filterable
    remote
    reserve-keyword
    placeholder="请输入关键词搜索店铺"
    size="small"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="changeInput"
    class="select-input"
    :multiple-limit="1"
    v-if="!loading"
    :disabled="isDisabled"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.shopName"
      :value="item.id"
    >
      <span style="float: left">{{ item.shopName }}</span>
      <span
        style="
          float: right;
          color: #8492a6;
          font-size: 13px;
          padding-left: 20px;
        "
      >
        <span v-if="item.companyName"> {{ item.companyName }}/</span>
        <span v-if="item.concatName">{{ item.concatName }}/</span>
        <span v-if="item.concatPhone">{{ item.concatPhone }}/</span>
        在售商品数:{{ item.onSaleCount }}</span
      >
    </el-option>
  </el-select>
</template>
<script>
import avater from "/public/img/default.png";
import {
  queryShopListByKeyword,
  activityRulesAdd,
} from "@/api/platActivityManage";

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      shopIdArr: [],
    };
  },
  computed: {},
  created() {
    // this.init();
  },
  methods: {
    changeInput(e) {
      console.log(e, "e");
      // console.log(this.shopIdArr,'this.shopIdArr')
      console.log(this.options, "--this.options");
      let shopName = "";
      let id = "";
      this.options.map((item) => {
        if (item.id == e) {
          shopName = item.shopName;
          id = item.id;
        }
      });
      console.log(shopName, "shopName");
      this.$emit("chooseShop", [id, shopName]);
    },
    remoteMethod(queryString) {
      let params = {};
      let restaurants = [];
      params.keyword = queryString;
      // 根据店铺名或手机号搜索店铺
      queryShopListByKeyword(params)
        .then((res) => {
          if (res) {
            restaurants = res;
            if (queryString !== "") {
              this.options = restaurants.filter((item) => {
                if (!item.shopName) return false;
                return (
                  item.shopName
                    .toLowerCase()
                    .indexOf(queryString.toLowerCase()) > -1
                );
              });
            } else {
              this.options = [];
            }
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    init(id, name) {
      this.loading = true;
      this.shopIdArr = [id];
      // this.remoteMethod('湖南永正医药有限公司1')
      if (name) {
        this.remoteMethod(name);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.select-input {
  width: 240px;
}
</style>
